module.exports = __webpack_public_path__ + "qr1.a5478214.png";